// extracted by mini-css-extract-plugin
export var equalColumn = "_hy-0";